import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment TeamSearchInput_org on Org {
      id
    }
  `,
  viewer: graphql`
    fragment TeamSearchInput_viewer on Viewer
    @argumentDefinitions(orgRelayId: { type: "ID!" }, query: { type: "String!" }) {
      teamQueryResultErrorable(query: $query, orgRelayId: $orgRelayId) {
        ... on TeamQueryResult {
          query
          teams {
            teamName
          }
        }
      }
    }
  `,
};
